import { render, staticRenderFns } from "./TourGroups.vue?vue&type=template&id=7115fbb9"
import script from "./TourGroups.vue?vue&type=script&lang=js"
export * from "./TourGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports